import { createAction } from 'typesafe-actions';

export const changeUndergroundTimeAction = createAction(
  'filters/undergroundTimeChanged',
  (event: React.ChangeEvent<HTMLInputElement>) => Number(event.target.value),
)<number>();
